import React from 'react';
import {
  Dropdown,
  DropdownSkeleton,
  InlineLoading,
  TooltipIcon
} from 'carbon-components-react';
import { Information16, HelpFilled16, Maximize16 } from '@carbon/icons-react';
import { HTMLViewer, ImageViewer, PDFViewer, IFrameViewer } from 'components';

export const ResponsesContent: React.FC<Props | any> = (props: Props) => {
  const {
    selectedReferralObj,
    enquiryValidityDate,
    loadingEmailPreview,
    viewItem,
    handleViewChange,
    previewData,
    handleExpandClick,
    initialSelectedViewItem,
    isLoadingPreviewer,
    inboundEmailId
  } = props;
  const attachmentDropdownTooltip = (
    <TooltipIcon
      tooltipText={'Access the response documents directly'}
      className="tooltip"
    >
      <HelpFilled16 className="tooltip-icon" />
    </TooltipIcon>
  );
  const attachmentDropdownTitleText = (
    <div className="title-text">
      <div>View or download</div>
      <div>{attachmentDropdownTooltip}</div>
    </div>
  );

  return (
    <div className="get-responses-responses-content">
      <div className="get-responses-responses-content-menus">
        <div className="get-responses-responses-content-menus-referral">
          <div>
            <div className="get-responses-responses-content-menus-referral-logo">
              {selectedReferralObj?.LogoImageFile?.id ? (
                <img
                  src={`${process.env.REACT_APP_RSOTF_API_URL}/community/organisations/${selectedReferralObj.id}/logo`}
                  alt=""
                  className="ao-logo"
                  title={selectedReferralObj.name}
                />
              ) : (
                <div className="ao-name" title={selectedReferralObj.name}>
                  {selectedReferralObj.name}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="get-responses-responses-content-menus-options">
          <div className="get-responses-responses-content-menus-options-attachments">
            {!loadingEmailPreview && viewItem.length > 0 && (
              <Dropdown
                id="attachments"
                titleText={attachmentDropdownTitleText}
                label="Select"
                size="xl"
                className="dropdown attachment-dropdown"
                initialSelectedItem={initialSelectedViewItem}
                onChange={(item: any) =>
                  handleViewChange(item?.selectedItem?.value)
                }
                items={viewItem}
              />
            )}

            {!loadingEmailPreview && viewItem.length === 0 && (
              <Dropdown
                id="attachments"
                titleText={attachmentDropdownTitleText}
                label="Select"
                size="xl"
                className="dropdown attachment-dropdown"
                items={[]}
              />
            )}

            {loadingEmailPreview && (
              <DropdownSkeleton className="dropdown-skeleton" />
            )}
          </div>
          {selectedReferralObj.status === 'COMPLETED' && (
            <div className="get-plans-responses-content-menus-options-expand">
              <div
                className={`icon-circle ${
                  previewData?.type === 'link' ||
                  previewData?.type === 'unknown'
                    ? 'disable-expand'
                    : ''
                }`}
                onClick={
                  previewData?.type === 'link' ||
                  previewData?.type === 'unknown'
                    ? undefined
                    : handleExpandClick
                }
              >
                <Maximize16 />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="get-responses-responses-content-viewer">
        <div className="get-responses-responses-content-viewer-previewer">
          {loadingEmailPreview && (
            <div className="spinner-loader">
              <InlineLoading description="Preparing response view ..." />
            </div>
          )}
          {!loadingEmailPreview &&
            previewData?.type === 'webMap' &&
            previewData?.body && (
              <IFrameViewer
                className="get-responses-responses-content-viewer-previewer-webmap"
                source={previewData?.body}
                selectedData={selectedReferralObj}
                title={'Web map'}
              />
            )}
          {!loadingEmailPreview &&
            previewData?.type === 'html' &&
            previewData?.body && (
              <HTMLViewer
                html={previewData?.body}
                title="Response body"
                referralId={selectedReferralObj?.externalId}
                inboundEmailId={inboundEmailId}
              />
            )}
          {!loadingEmailPreview &&
            previewData?.type === 'image' &&
            previewData?.body && (
              <ImageViewer
                fileId={previewData?.id}
                imageSource={previewData?.body}
                imageName={previewData?.name}
              />
            )}
          {!loadingEmailPreview &&
            previewData?.type === 'pdf' &&
            previewData?.body &&
            !isLoadingPreviewer && (
              <PDFViewer
                fileId={previewData?.id}
                fileUrl={previewData?.body}
                fileName={previewData?.name}
                viewerContentHeight={`24rem`}
              />
            )}
        </div>
        <div className="get-responses-responses-content-viewer-footer">
          <Information16 />
          {`This enquiry is valid until ${enquiryValidityDate}`}
        </div>
      </div>
    </div>
  );
};

type ownProps = {
  selectedReferralObj: any;
  selectedReferral: Number;
  enquiryValidityDate: String;
  loadingEmailPreview: boolean;
  viewItem: any;
  handleViewChange: Function;
  previewData: any;
  handleExpandClick: any;
  initialSelectedViewItem: any;
  isLoadingPreviewer: boolean;
  inboundEmailId?: number;
};

type Props = ownProps;

ResponsesContent.displayName = 'ResponsesContent';

export default React.memo(ResponsesContent);
